<template>
  <div class="tw:z-0 tw:shrink-0 tw:inline-flex tw:items-center tw:bg-muted tw:p-2 tw:rounded tw:border tw:first:border-r-0 tw:last:border-l-0">
    <slot />
  </div>
</template>

<script setup>
defineOptions({
  name: 'InputGroupText',
})
</script>
